import { useCallback, useState, type ReactNode } from 'react';

type CloseModal<ResultType> = (result: ResultType) => void;

type ModalFactory<ResultType> = (close: CloseModal<ResultType>) => ReactNode;

export const useConfirm = () => {
  const [modalNode, setModalNode] = useState<ReactNode>(null);

  const openModal = useCallback(
    <ModalResult,>(modalFactory: ModalFactory<ModalResult>) =>
      new Promise<ModalResult>((resolve) => {
        function close(value: ModalResult) {
          resolve(value);
          setModalNode(null);
        }
        setModalNode(modalFactory(close));
      }),
    [],
  );

  return [modalNode, openModal] as const;
};
